import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NoteBuilderContextComponent } from './note-builder-context.component';
import { NoteBuilderContextRoutingModule } from './note-builder-context-routing';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    NoteBuilderContextComponent,
  ],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    NoteBuilderContextRoutingModule,

    // material
    MatButtonModule,
    MatTooltipModule,
    MatInputModule
  ],
  exports: [
    NoteBuilderContextComponent
  ]
})
export class NoteBuilderContextModule { }
